import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { FeatureFlag, useFeatureFlag } from '../../Contexts/FeatureFlagContext';
import { useApplication } from '../../Contexts/ApplicationContext';
import { AddressPageFirstScreen } from './AddressPageFirstScreen';
import { InformationScreens } from './InformationScreens';
import { useAnalytics } from '../../Contexts/AnalyticsContext';
var AddressPageScreens;
(function (AddressPageScreens) {
    AddressPageScreens[AddressPageScreens["ADDRESS_INPUT"] = 0] = "ADDRESS_INPUT";
    AddressPageScreens[AddressPageScreens["FIRST_INFORMATION_SCREEN"] = 1] = "FIRST_INFORMATION_SCREEN";
    AddressPageScreens[AddressPageScreens["SECOND_INFORMATION_SCREEN"] = 2] = "SECOND_INFORMATION_SCREEN";
    AddressPageScreens[AddressPageScreens["THIRD_INFORMATION_SCREEN"] = 3] = "THIRD_INFORMATION_SCREEN";
})(AddressPageScreens || (AddressPageScreens = {}));
export var AddressPageManager = function () {
    var _a = useState(AddressPageScreens.ADDRESS_INPUT), screen = _a[0], setScreen = _a[1];
    var isWalletCreationEnable = useFeatureFlag(FeatureFlag.WALLET_CREATION);
    var _b = useApplication(), stepController = _b.stepController, orderFacade = _b.orderFacade;
    var track = useAnalytics().track;
    var _c = useState(false), creationWalletLoader = _c[0], setCreationWalletLoader = _c[1];
    var _d = useState(), creationWalletError = _d[0], setCreationWalletError = _d[1];
    var walletCreationInfo = useMemo(function () {
        return 'walletCreation' in stepController.currentStep
            ? stepController.currentStep.walletCreation
            : undefined;
    }, [stepController.currentStep]);
    var _e = useMemo(function () { return getMinMaxOfEnum(AddressPageScreens); }, []), stepsCount = _e[1];
    var handleIncrementSteps = useCallback(function () {
        track("initial_create_wallet_clicked_step_".concat(screen + 1));
        setScreen(function (screen) {
            return screen + 1;
        });
    }, [track, screen]);
    var handleDecrementSteps = useCallback(function () {
        track("initial_create_wallet_clicked_return_step_".concat(screen - 1));
        setScreen(function (screen) { return screen - 1; });
    }, [screen, track]);
    var handleWalletCreate = useCallback(function () {
        setCreationWalletLoader(true);
        setCreationWalletError(undefined);
        orderFacade
            .createWallet()
            .then(function () {
            track('create_wallet_clicked');
        })
            .catch(function (err) {
            var _a, _b;
            setCreationWalletError((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message);
        })
            .finally(function () {
            setCreationWalletLoader(false);
        });
    }, [orderFacade, track]);
    var showWalletCreationBtn = useMemo(function () {
        return walletCreationInfo && walletCreationInfo.type !== 'UNSUPPORTED';
    }, [walletCreationInfo]);
    var handleWalletCreation = useCallback(function () {
        if (!walletCreationInfo)
            return;
        switch (walletCreationInfo.type) {
            case 'EXTERNAL':
                window.open(walletCreationInfo.url, '_blank');
                return;
            case 'INTERNAL':
                handleIncrementSteps();
                return;
            case 'UNSUPPORTED':
                return;
        }
    }, [walletCreationInfo, handleIncrementSteps]);
    var walletCreationProps = useMemo(function () {
        return isWalletCreationEnable && showWalletCreationBtn
            ? {
                secondaryButtonLabel: 'I need a wallet',
                onSecondaryButtonClick: handleWalletCreation,
                secondaryButtonLoader: creationWalletLoader,
            }
            : undefined;
    }, [
        isWalletCreationEnable,
        showWalletCreationBtn,
        handleWalletCreation,
        creationWalletLoader,
    ]);
    var renderScreen = useCallback(function () {
        switch (screen) {
            case AddressPageScreens.ADDRESS_INPUT:
                return (_jsx(AddressPageFirstScreen, { walletCreationProps: walletCreationProps }));
            case AddressPageScreens.FIRST_INFORMATION_SCREEN:
                return (_jsx(InformationScreens, { stepsCount: stepsCount, stepNumber: AddressPageScreens.FIRST_INFORMATION_SCREEN, label: "Simple use", text: "Your wallet is created instantly. After wallet creation, follow the instructions below.", footer: {
                        buttonClick: handleIncrementSteps,
                        actionButtonLabel: 'Next',
                    }, customBackClick: handleDecrementSteps }));
            case AddressPageScreens.SECOND_INFORMATION_SCREEN:
                return (_jsx(InformationScreens, { stepsCount: stepsCount, label: "Security solutions", text: "Verification of email address and phone number with a 10-digit code.", stepNumber: AddressPageScreens.SECOND_INFORMATION_SCREEN, footer: {
                        buttonClick: handleIncrementSteps,
                        actionButtonLabel: 'Next',
                    }, customBackClick: handleDecrementSteps }));
            case AddressPageScreens.THIRD_INFORMATION_SCREEN:
                return (_jsx(InformationScreens, { stepsCount: stepsCount, label: "Secret Seed Phrase", text: "Private key with which you can use your wallet. Don't share it with anyone!", stepNumber: AddressPageScreens.THIRD_INFORMATION_SCREEN, footer: {
                        buttonClick: handleWalletCreate,
                        actionButtonLoader: creationWalletLoader,
                        actionButtonLabel: 'Create wallet',
                        actionBtnError: creationWalletError
                            ? 'Something went wrong. Try again'
                            : undefined,
                    }, customBackClick: handleDecrementSteps }));
        }
    }, [
        creationWalletError,
        creationWalletLoader,
        handleDecrementSteps,
        handleIncrementSteps,
        handleWalletCreate,
        screen,
        stepsCount,
        walletCreationProps,
    ]);
    return _jsx(_Fragment, { children: renderScreen() });
};
function getMinMaxOfEnum(e) {
    var values = Object.keys(e)
        .map(function (k) { return (k === '' ? NaN : +k); })
        .filter(function (k) { return !isNaN(k); })
        .sort(function (k1, k2) { return k1 - k2; });
    return [values[0], values[values.length - 1]];
}
